import React, {  Component } from 'react';

export default class Header extends Component {
	render() {
	    return (
			<div className="masthead-sub-row">
				<div className="column masthead-logo-column">
					<div className="masthead">
						<div className="customerNetLogo">
							<img className="customerNetLogo" src="/images/GE-CNet-logo.png" alt="GE CustomerNet" title="GE CustomerNet" />
						</div>
					</div>
				</div>
				<div className="column masthead-house-of-brands-column">
					<div className="masthead-house-of-brands-wrapper">
						<ul className="hob-lockup-list">
							<li className="hob-lockup-list-item item-hob-monogram">
								<a href="http://www.monogram.com" target="_blank"><img src="/images/Monogram-logo@2x.png" alt="Monogram" title="Monogram" /></a>
							</li>
							<li className="hob-lockup-list-item item-hob-cafe">
								<a href="http://www.cafeappliances.com" target="_blank"><img src="/images/Cafe-logo@2x.png" alt="Café" title="Café" /></a>
							</li>
							<li className="hob-lockup-list-item item-hob-ge">
								<a href="http://www.geappliances.com" target="_blank"><img src="/images/GE-logo@2x.png" alt="GE" title="GE" /></a>
							</li>
							<li className="hob-lockup-list-item item-hob-profile">
								<a href="http://www.geprofile.com" target="_blank"><img src="/images/Profile-logo@2x.png" alt="Profile" title="Profile" /></a>
							</li>
							<li className="hob-lockup-list-item item-hob-haier">
								<a href="http://www.haierappliances.com" target="_blank"><img src="/images/Haier-logo@2x.png" alt="Haier" title="Haier" /></a>
							</li>
							<li className="hob-lockup-list-item item-hob-hotpoint">
								<a href="http://www.hotpoint.com" target="_blank"><img src="/images/Hotpoint-logo@2x.png" alt="Hotpoint" title="Hotpoint" /></a>
							</li>
						</ul>
					</div>
				</div>
	  		</div>
	    );
	}
}



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/common/Header/index.js